export const PROMO_GUIDE_SHEET_LINK = 'https://f.sravni.ru/cms/actions/mfo/action_mfo_october_2025.pdf';
